import React, {PropsWithChildren} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {IntlDictionary} from './LocaleProvider';

// interface InjectMessageProps {
//   id2: string
// }
const InjectMassage = (props: any) => <FormattedMessage {...props} />;

const injectionFunction = injectIntl(InjectMassage, {
  forwardRef: false,
});

const IntlMessages = (props: PropsWithChildren<{id: IntlDictionary}>) => injectionFunction(props);

export default IntlMessages;
